import * as Actions from 'actionTypes';
import { getKey } from 'Common/formValues';

const isSortByDistance = _ => _ && getKey(_) === 'distance';
const shouldDeleteSort = (isPostCodeValid, sortBy) =>
  isPostCodeValid === false && isSortByDistance(sortBy);

const shouldDefaultSortToDistance = (isPostCodeValid, sortBy) =>
  isPostCodeValid && !sortBy;

const postCodeAction = (state, action) => {
  if (shouldDeleteSort(action.result.isValid, state.values.sortBy)) {
    delete state.values.sortBy;
  }

  if (shouldDefaultSortToDistance(action.result.isValid, state.values.sortBy)) {
    state.values.sortBy =
      '{"key":"distance","sortBy":"distance","sort":"asc","display":"Distance"}';
  }

  return {
    ...state,
    values: {
      ...state.values,
      isPostCodeValid: action.result.isValid
    }
  };
};

const formReducer = (state, action) => {
  if (state) {
    switch (action.type) {
      case Actions.ADD_POSTCODE_RESULT:
        return postCodeAction(state, action);
      case '@@redux-form/CHANGE':
        if (action.meta.field === 'postCode') {
          return {
            ...state,
            values: {
              ...state.values
            }
          };
        }
        return state;
      default:
        return state;
    }
  }
};

const customForm = {
  filter: formReducer,
  search: formReducer
};

export default customForm;



// WEBPACK FOOTER //
// ./src/reducers/custom-form/index.js